// Helper function to check if domain is blocked
export const checkDomainBlocked = (parentUrl, whitelistedDomains) => {
  if (!parentUrl || !whitelistedDomains || whitelistedDomains.length === 0) {
    return false; // No restrictions if no domains specified
  }

  try {
    // Decode the URL if it's encoded
    const decodedUrl = decodeURIComponent(parentUrl);
    const url = new URL(decodedUrl);
    const currentDomain = url.hostname.toLowerCase();

    // Check if current domain matches any whitelisted domain or subdomain
    const isAllowed = whitelistedDomains.some(allowedDomain => {
      const normalizedAllowed = allowedDomain.toLowerCase();

      // Exact match
      if (currentDomain === normalizedAllowed) {
        return true;
      }

      // Subdomain match (e.g., www.example.com matches example.com)
      if (currentDomain.endsWith('.' + normalizedAllowed)) {
        return true;
      }

      return false;
    });

    return !isAllowed;
  } catch (error) {
    console.error('Error checking domain:', error);
    return true; // Block if we can't parse the URL
  }
};


